// Package Imports
// import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
// import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );

const PerformanceDashboard = lazy(
  () => import('pages/performanceDashboard/performanceDashboard')
);
// const PerformanceDashboard = lazy(
//   () => import('pages/accounting/dashboard/accountingDashboard')
// );
const PerformanceDashboardRoute = (
  <Route path={routeName.performanceDashboard}>
    <Route
      index
      element={
        // <PrivateRoute name={PrivateRouteConst.PERFORMANCE_DASHBOARD}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <PerformanceDashboard />
        </Suspense>
        // </PrivateRoute>
      }
    />
  </Route>
);

export default PerformanceDashboardRoute;
